import { render } from "./iconLogout.vue?vue&type=template&id=5c68c8d7"
import script from "./iconLogout.vue?vue&type=script&lang=js"
export * from "./iconLogout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__